import { Component, OnInit, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { NumberBinaryQualifierService } from 'src/app/model/api-services/qualifiers/number-binary-qualifier.service';
import { NumberHexQualifierService } from 'src/app/model/api-services/qualifiers/number-hex-qualifier.service';
import { NumberOctalQualifierService } from 'src/app/model/api-services/qualifiers/number-octal-qualifier.service';
import { SLLayer } from 'src/app/model/sl-layer';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';

export type InputMode = 'BIN' | 'DEC' | 'HEX' | 'OCT';

@Component({
	selector: 'app-number-binary-input',
	templateUrl: './number-binary-input.component.html',
	styleUrls: ['./number-binary-input.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NumberBinaryInputComponent extends InputComponent implements OnInit {

	public inputMode: InputMode = 'DEC';
	public valueString = '';
	public numericValue = 0;
	constructor(private domNode: ElementRef,protected cdr: ChangeDetectorRef) {
		super(cdr);
		super._domNode = this.domNode;
	}

	public set currentValue(val: any) {
		super.currentValue = val;
		// this.UpdateFromValue();
	}
	public get currentValue(): any {
		return super.currentValue;
	}
	public SetAttribute(layer: SLLayer, attribute: AttributeInfo) {
		super.SetAttribute(layer, attribute);
		let mode: InputMode = 'DEC';
		switch (this.attribute.casting.entry.type) {
			case 'number-binary':
				mode = 'BIN';
				break;
		}
		this.SetMode(mode);

	}
	UpdateFromValue() {
		if (['string', 'text'].indexOf(this.attribute.type) > -1) {
			this.valueString = this.currentValue;
			this.numericValue = NumberBinaryQualifierService.FromString(this.valueString, this.attribute.casting.entry.format);
		} else {
			this.numericValue = this.currentValue;
			this.valueString = NumberBinaryQualifierService.ToString(this.numericValue, this.attribute.casting.entry.format);
		}
	}
	SetMode(inputMode: InputMode) {
		if (this.valueString !== '') {
			this.numericValue = this.GetNumeric(this.inputMode);
		}
		this.inputMode = inputMode;
		if (this.valueString !== '') {
			this.UpdateValueString(this.inputMode);
			this.UpdateFromNumeric();
		}

	}
	UpdateValueString(mode: InputMode) {
		switch (mode) {
			case 'DEC':
				this.valueString = '' + this.numericValue;
				break;
			case 'BIN':
				this.valueString = NumberBinaryQualifierService.ToString(this.numericValue, 'binary');
				break;
			case 'HEX':
				this.valueString = NumberHexQualifierService.ToString(this.numericValue, 'hex').toUpperCase();
				break;
			case 'OCT':
				this.valueString = NumberOctalQualifierService.ToString(this.numericValue, 'octal');
				break;

		}
	}
	UpdateFromNumeric() {
		if (['string', 'text'].indexOf(this.attribute.type) > -1) {
			this.currentValue = NumberBinaryQualifierService.ToString(this.numericValue, this.attribute.casting.entry.format);
		} else {
			this.currentValue = this.numericValue;
		}
	}
	GetNumeric(mode: InputMode) {
		switch (mode) {
			case 'DEC':
				const decDigits = this.valueString.match(/[0123456789]/g);
				if (decDigits !== null) {
					this.valueString = decDigits.join('');
				} else {
					this.valueString = '';
				}
				return Number(this.valueString);
			case 'BIN':
				return NumberBinaryQualifierService.FromString(this.valueString, 'binary');
			case 'HEX':
				return NumberHexQualifierService.FromString(this.valueString, 'hex');
			case 'OCT':
				return NumberOctalQualifierService.FromString(this.valueString, 'octal');
		}
	}
	InputChanged() {
		const numeric: number = this.GetNumeric(this.inputMode);
		if (this.numericValue === numeric) {
			return;
		}

		if (this.inputMode === 'HEX') {
			this.valueString = this.valueString.toUpperCase();
		}

		if (['text', 'string'].indexOf(this.attribute.type) > -1) {
			this.currentValue = NumberBinaryQualifierService.ToString(numeric, this.attribute.casting.entry.format);
		} else {
			this.currentValue = numeric;
		}
		this.numericValue = numeric;
	}


}
